import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/index',
      name: 'index',
      component:()=> import('@/components/index')
    },
    {
      path: '/video_sy',
      name: 'video_sy',
      component:()=> import('@/components/video_sy')
    },
    {
      path: '/video',
      name: 'video',
      component:()=> import('@/components/video')
    },
    {
      path: '/video_app',
      name: 'video_app',
      component:()=> import('@/components/video_app')
    },
    {
      path: '/404',
      name: '404',
      component:()=> import('@/components/404')
    },




   
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js